<template>
  <div id="app">
    <component :is="layout">
      <vue-page-transition name="fade-in-right">
        <router-view :key="$route.fullPath" />
      </vue-page-transition>
    </component>
  </div>
</template>
<script>
const defaultLayout = 'default';
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout';
    }
  },
  created() {},
  metaInfo: {
    title: 'Emerging: Driving Employability',
    meta: [
      {
        property: 'og:title',
        vmid: 'og-title',
        content: 'Emerging: The Global Employability University Ranking & Survey'
      },
      { property: 'og:image', content: '//www.emerging.fr/assets/img/internet-logo.png' },
      {
        property: 'og:description',
        vmid: 'og-description',
        content:
          'Connecting companies and Higher Education, the Emerging group forms a leading international hub for graduate employability.'
      },
      { property: 'og:url', content: 'Test title' }
    ]
  }
};
</script>
<style>
.ranking-head {
  background: #142541;
  color: white;
}

.sr-only {
  color: white;
}
.page-item button {
  background: white;
  color: grey;
}

.page-item.active .page-link {
  background: #ff6839;
  color: white;
  border-color: #ff6839;
}
</style>
